<template>
  <div id="login" class="nr">
    <div class="center">
      <div class="tit">
        <h2>APP下載</h2>
      </div>
      <div class="ctnr">
        <div class="r-content">
          <div
            v-for="(item, index) in downloadList"
            class="download__container"
            :key="index"
          >
            <a :href="item.url" target="_blank" class="download__name">
              <span class="download__button">
                {{ item.name }}
              </span>
            </a>
            <img :src="item.image" class="download__img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <CompFoot />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  components: {
    CompFoot: require("@/components/parts/Foot").default,
  },
  computed: {
    ...mapState({
      downloadList: (state) => state.appsetting.downloadList,
    }),
  },
  data() {
    return {};
  },
  methods: {
    async getDownloadList() {
      await this.$store.dispatch("appsetting/getDownloadList");
    },
  },
  async mounted() {
    await this.getDownloadList();
  },
};
</script>
<style scoped>
@import "~@/assets/css/enroll.css";
.download__container {
  margin-top: 0.8rem;
}
.download__name {
  font-size: 0.36rem !important;
  color: #e5e5e5 !important;
  display: block !important;
  margin: 0 auto !important;
  text-align: center !important;
  border: none !important;
}
.download__img {
  margin-top: 0.4rem;
  width: 138px;
  height: 138px;
  display: block;
  margin: 0.4rem auto;
}

.download__button {
  display: inline-block;
  width: 5rem;
  line-height: .8rem;
  font-size: .4rem;
  background-color: rgb(136, 47, 128);
}
</style>
